<template>
    <div class="plannig-map">
        <div class="plannig-map-menu">
            <div class="menu-item" v-bind:class="{'menu-item-active font-color':menuActive==='0'}" @click="handleMenuClick('0')">近期</div>
            <div class="menu-item" v-bind:class="{'menu-item-active font-color':menuActive==='1'}" @click="handleMenuClick('1')">远期</div>
        </div>
        <img :src="imageUrl[menuActive]"/>
    </div>
</template>

<script>
export default {
    name: "PlanningMap",
    data() {
        return {
            menuActive: '0', //底部菜单切换
            imageUrl: [
                require('../../assets/images/digital/map-near.png'),
                require('../../assets/images/digital/map-forward.png')
            ]
        }
    },
    methods: {
        //底部菜单点击
        handleMenuClick(data) {
            this.menuActive = data
        },
    }
}
</script>

<style lang="scss" scoped>
.plannig-map {
    width: 100%;
    height: 100vh;
    .plannig-map-menu {
        z-index: 10;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 82px;
        width: 200px;
        height: 40px;
        background: rgba(7, 17, 41, 0.85);
        border-radius: 3px;
        padding: 6px;
        font-size: 16px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .menu-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 100%;
            cursor: pointer;
            border-radius: 3px;
        }
        .menu-item-active {
            background: linear-gradient(180deg, rgba(27, 109, 183, 0), rgba(27, 109, 183, 0.72));
        }
    }
    img {
        z-index: 10;
        width: 100%;
        height: 100%;
    }
}
</style>